var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"novedad-highlight"},[(_vm.etiqueta)?_c('span',{staticClass:"novedad-highlight-etiqueta"},[_vm._v(_vm._s(_vm.etiqueta))]):_vm._e(),_vm._v(" "),_vm._t("default")],2):_c('div',{staticClass:"novedad-highlight-apagado"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-581f1e23","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Novedad/NovedadHighlight.vue
// module id = HYId
// module chunks = 4